// Night light switch
export enum NightLightsStateEnum {
  CLOSE = 0, // 0-off
  OPEN = 1, // 1-on
}

// Distance limit switch
export enum DistanceLimitStatusEnum {
  UNSET = 0, // 0-not set
  SET = 1, // 1-set
}

export interface DistanceLimitStatus {
  state?: DistanceLimitStatusEnum;
  distance_limit?: number; // Distance limit
}

// Obstacle avoidance
export enum ObstacleAvoidanceStatusEnum {
  CLOSE = 0, // 0-off
  OPEN = 1, // 1-on
}

export interface ObstacleAvoidance {
  horizon?: ObstacleAvoidanceStatusEnum;// Horizontal obstacle avoidance switch
  upside?: ObstacleAvoidanceStatusEnum;// Upward obstacle avoidance switch
  downside?: ObstacleAvoidanceStatusEnum;// Downward obstacle avoidance switch
}

// Device management setting keys
export enum DeviceSettingKeyEnum {
  NIGHT_LIGHTS_MODE_SET = 'night_lights_state', // Night light switch
  HEIGHT_LIMIT_SET = 'height_limit', // Height limit setting
  DISTANCE_LIMIT_SET = 'distance_limit_status', // Distance limit switch
  OBSTACLE_AVOIDANCE_HORIZON = 'obstacle_avoidance_horizon', // Horizontal obstacle avoidance state
  OBSTACLE_AVOIDANCE_UPSIDE = 'obstacle_avoidance_upside', // Upward obstacle avoidance state
  OBSTACLE_AVOIDANCE_DOWNSIDE = 'obstacle_avoidance_downside', // Downward obstacle avoidance state
}

export type DeviceSettingType = Record<DeviceSettingKeyEnum, any>

export const initDeviceSetting = {
  [DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET]:
  {
    label: 'Aircraft night light',
    value: '',
    trueValue: NightLightsStateEnum.CLOSE,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'To ensure operation safety, keep the night light on',
      label: 'Aircraft night light',
    },
    settingKey: DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET,
  },
  [DeviceSettingKeyEnum.HEIGHT_LIMIT_SET]:
  {
    label: 'Height limit',
    value: '',
    trueValue: 120,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Height limit: 20 - 1500m',
      // info: 'Changing the height limit affects all tasks of this dock; confirm operations before modifying',
      label: 'Height limit',
    },
    settingKey: DeviceSettingKeyEnum.HEIGHT_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.DISTANCE_LIMIT_SET]:
  {
    label: 'Distance limit',
    value: '',
    trueValue: DistanceLimitStatusEnum.UNSET,
    // info: 'Distance limit (15 - 8000m) constrains the max operating distance of the aircraft from the dock',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Distance limit (15 - 8000m) constrains the max operating distance of the aircraft from the dock',
      // info: 'Changing the distance limit affects all tasks of this dock; confirm operations before modifying',
      label: 'Distance limit',

    },
    settingKey: DeviceSettingKeyEnum.DISTANCE_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON]:
  {
    label: 'Horizontal obstacle avoidance',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: 'Shows the aircraft obstacle avoidance status; toggle it quickly here, or configure it further on the device maintenance page',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Obstacle avoidance is a basic flight safety feature; keep it enabled',
      label: 'Horizontal obstacle avoidance',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE]:
  {
    label: 'Upward obstacle avoidance',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: 'Shows the aircraft obstacle avoidance status; toggle it quickly here, or configure it further on the device maintenance page',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Obstacle avoidance is a basic flight safety feature; keep it enabled',
      label: 'Upward obstacle avoidance',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE]:
  {
    label: 'Downward obstacle avoidance',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: 'Shows the aircraft obstacle avoidance status; toggle it quickly here, or configure it further on the device maintenance page',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Obstacle avoidance is a basic flight safety feature; keep it enabled',
      label: 'Downward obstacle avoidance',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE,
  },
} as DeviceSettingType

export const initDeviceSettingFormModel = {
  nightLightsState: false, // Night light switch
  heightLimit: 20, // Height limit setting
  distanceLimitStatus: { state: false, distanceLimit: 15 }, // Distance limit switch
  obstacleAvoidanceHorizon: false, // Obstacle avoidance - horizontal switch
  obstacleAvoidanceUpside: false, // Obstacle avoidance - upward switch
  obstacleAvoidanceDownside: false, // Obstacle avoidance - downward switch
}

export type DeviceSettingFormModel = typeof initDeviceSettingFormModel
